<template>
	<v-container>
		<v-row align="center">
			<!-- <v-col v-for="(link, i) in links" :key="i" class="text-center" cols="6" md="auto">
				<a :href="link.href" class="text-decoration-none text-uppercase text-caption font-weight-regular" rel="noopener" target="_blank" style="letter-spacing:normal!important" v-text="link.text" />
			</v-col> -->

			<v-spacer class="hidden-sm-and-down" />

			<!-- <v-col cols="12" md="auto">
				<div class="font-weight-light pt-6 pt-md-0 text-center">
					&copy; <span style="font-family:tahoma">{{ (new Date()).getFullYear() }}</span>, تحلیلگر سیستم:
					<a href="https://jetafzaar.ir/" class="text-decoration-none purple--text" target="_blank">جــت افزار</a>
				</div>
			</v-col> -->
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'Links',

		data: () => ({
			links: [
				{
					href: 'https://www.instagram.com/avizheh_gold_shiraz/',
					text: 'اینستاگرام',
				},
				{
					href: 'https://www.tala.ir',
					text: 'پورتال طلا و جواهر',
				},
				{
					href: 'https://www.tgju.org',
					text: 'اخبار',
				},
			],
		}),
	}
</script>

<style lang="sass" scoped>
a
	color: inherit !important
</style>
